import { getSafeLocalStorage } from '@shared-core/utils/safe-storage'
import { APP_STORAGE_STORE } from '@web/store/common'

export const storageState = {
  getString(key: string): string | undefined {
    return getSafeLocalStorage()?.getItem(`${APP_STORAGE_STORE}/${key}`) ?? undefined
  },

  set(key: string, value: string): void {
    const storage = getSafeLocalStorage()

    if (!storage) return

    const storageKey = `${APP_STORAGE_STORE}/${key}`

    try {
      storage.setItem(storageKey, value)
    } catch (_error) {}
  },

  clearAll(): void {
    const ls = getSafeLocalStorage()

    if (!ls) return

    const prefix = `${APP_STORAGE_STORE}/`

    for (const key of Object.keys(ls)) {
      if (key.startsWith(prefix)) {
        ls.removeItem(key)
      }
    }
  },
}
